import { useEffect, useRef, useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';

export function useOutsideClickTracker(ref, callback) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
}

export function useDebounce() {
  const TIMEOUT = 1300,
    currentTimeout = useRef();

  const debounce = useCallback(function debounce(func) {
    if (currentTimeout.current !== undefined) {
      window.clearTimeout(currentTimeout.current);
    }

    currentTimeout.current = window.setTimeout(func, TIMEOUT);
  }, []);

  return debounce;
}

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export function useResize() {
  const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });

  const handleResize = () => {
    setDimensions({ width: window.innerWidth, height: window.innerHeight });
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return dimensions;
}
